import PageHero from "@/components/common/PageHero";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import FinalCTA from "@/components/sections/FinalCTA";
import FAQ from "@/components/sections/FAQ";

export default function ServicesPage() {
  return (
    <main data-testid="services-page">
      <PageHero
        eyebrow="Services"
        title={<>Twelve disciplines.<br /><span className="text-gradient">One growth engine.</span></>}
        subtitle="From CRO-first Shopify design to global paid acquisition — Kavion offers everything ambitious D2C brands need to scale profitably."
      />
      <Services />
      <Process />
      <FAQ />
      <FinalCTA />
    </main>
  );
}
